import AnimTrackIndices from "./data-three/anim-track-indices.js";
import ObjectAnimTracks from "./data-three/object-anim-tracks.js";
import ObjectAnimValues from "./data-three/object-anim-values.js";
import ArrayToObjectCoords from "./data-three/array-to-object-coords.js";
import MorphTargetWeights from "./data-three/morph-target-weights.js";
import ObjectPosScaleFilter from "./data-three/object-pos-scale-filter.js";
import ObjectEulerToQuat from "./data-three/object-euler-to-quat.js";
import DeepMerge from "./data/deep-merge.js";

const EmptyObj = {};

class DataThree {
    constructor(wrapCtx, evtCtx) {
        this._wrapCtx = wrapCtx;
        this._evtCtx = evtCtx;

        this._animTrackIndices = new AnimTrackIndices(wrapCtx, evtCtx);
        this._objectAnimTracks = new ObjectAnimTracks(wrapCtx, evtCtx);
        this._objectAnimValues = new ObjectAnimValues(wrapCtx, evtCtx);
        this._objectAnimCoords = new ArrayToObjectCoords(wrapCtx, evtCtx);
        this._morphTargetWeights = new MorphTargetWeights(wrapCtx, evtCtx);
        this._objectStaticPosScale = new ObjectPosScaleFilter(wrapCtx, evtCtx);
        this._objectStaticQuat = new ObjectEulerToQuat(wrapCtx, evtCtx);
        this._objectFinalCoords = new DeepMerge(wrapCtx, evtCtx);
    }

    get animTrackIndices() { return this._animTrackIndices; }
    get objectAnimTracks() { return this._objectAnimTracks; }
    get objectAnimValues() { return this._objectAnimValues; }
    get objectAnimCoords() { return this._objectAnimCoords; }
    get morphTargetWeights() { return this._morphTargetWeights; }
    get objectStaticPosScale() { return this._objectStaticPosScale; }
    get objectStaticQuat() { return this._objectStaticQuat; }
    get objectFinalCoords() { return this._objectFinalCoords; }

    track(session, data, animations) {
        if (session || data || animations) {
            const {
                objectNames,
                objectAnimKeys,
                objectCoordinates,
            } = data || EmptyObj;

            this._animTrackIndices.track(animations);
            this._objectAnimTracks.track(objectNames, objectAnimKeys, this._animTrackIndices.tracks);
            this._objectAnimValues.track(session, objectAnimKeys, this._objectAnimTracks.tracks, animations);
            this._objectAnimCoords.track(this._objectAnimValues.values);
            this._morphTargetWeights.track(this._objectAnimValues.values);
            this._objectStaticPosScale.track(objectCoordinates);
            this._objectStaticQuat.track(objectCoordinates);
            this._objectFinalCoords.track(2, this._objectStaticPosScale.coords);
            this._objectFinalCoords.track(1, this._objectStaticQuat.coords);
            this._objectFinalCoords.track(0, this._objectAnimCoords.coords);
        } else {
            this._animTrackIndices.track();
            this._objectAnimTracks.track();
            this._objectAnimValues.track();
            this._objectAnimCoords.track();
            this._morphTargetWeights.track();
            this._objectStaticPosScale.track();
            this._objectStaticQuat.track();
            this._objectFinalCoords.track(2, null);
            this._objectFinalCoords.track(1, null);
            this._objectFinalCoords.track(0, null);
        }

        this.update();
    }

    update() {
        this._animTrackIndices.update();
        this._objectAnimTracks.update();
        this._objectAnimValues.update();
        this._objectAnimCoords.update();
        this._morphTargetWeights.update();
        this._objectStaticPosScale.update();
        this._objectStaticQuat.update();
        this._objectFinalCoords.update();
    }
}

export default DataThree;
